export const API_BASE_URL = 'https://bapi.aspire.eu/v1'
// export const API_BASE_URL = 'http://demo-bapi.benefitcz.cz/v1'
